<script>
	import Navbar from './CustomNavBar.svelte';
	import CustomFooter from './CustomFooter.svelte';
	import WelcomePage from './sections/WelcomePage.svelte'
	import About from './sections/About.svelte'
	import WebsiteProjects from './sections/Website_Projects.svelte';
	import AppProjects from './sections/App_Projects.svelte';
	import OtherProjects from './sections/Other_Projects.svelte';
	import Skills from './sections/Skills.svelte';
	import Contact from './sections/Contact.svelte';

	
</script>

<main>
	<!-- Navigation Bar -->
	<Navbar />

	<!-- Top Section / Welcome Page-->
	<WelcomePage />

	<!-- About me -->
	<About />

	<!-- App Projects -->
	<AppProjects />
	
	<!-- Website Projects -->
	<WebsiteProjects />

	<!-- Other Projects -->
	<OtherProjects />

	<!-- Skills -->
	<Skills />

	<!-- Contact -->
	<Contact />

	<!-- Footer -->
	<CustomFooter />

</main>

<style>
	
	
</style>